import { black, gray2, gray4, white } from "assets/styleUtils";
import { getCompanyReviewDetail, ICompanyReview } from "data/company";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import { Header } from "components";
import { menu } from "assets";
import { post } from "utils/ApiUtil";
import { toast, ToastContainer } from "react-toastify";
import useModal from "hooks/useModal";
import { SelectModal } from "modal/SelectModal";
import { userState } from "recoil/atoms";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { headerState } from "recoil/header";

export default function CompanyReviewDetailPage() {
  const props = useParams();
  const [review, setReview] = useState<ICompanyReview>();
  const [swiperRef, setSwiperRef] = useState<SwiperCore>();
  const [paging, setPaging] = useState(0);
  const navigate = useNavigate();
  const { visibleModal, removeModal } = useModal();
  const user = useRecoilValue(userState);

  function openModal() {
    visibleModal({
      id: "REVIEW_SELECT_MODAL",
      modalchildren: (
        <SelectModal
          buttonList={[
            {
              onClick: () => {
                removeModal("REVIEW_SELECT_MODAL");
                review &&
                  navigate("/company/detail/review/reviewwrite", {
                    state: {
                      contructor_no: String(props.contructor_no),
                      review_data: review,
                    },
                  });
              },
              text: "글 수정",
            },
            {
              onClick: () => {
                removeModal("REVIEW_SELECT_MODAL");
                deleteReview();
              },
              text: "글 삭제",
            },
          ]}
        />
      ),
      edge: "bottom",
    });
  }

  async function deleteReview() {
    if (!review) {
      return;
    }
    try {
      const res = await post("/api/contructor/updateReview", {
        type: "delete",
        contructor_no: review.contructor_no,
        no: review.no,
      });
      //백엔드 메세지가 잘못되어서 고정시킴
      toast.success("리뷰가 삭제되었습니다.");
      if (res.success) {
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      toast.error("에러가 발생했습니다. 관리자에게 문의해주세요.");
    }
  }

  async function getReview() {
    try {
      const {
        data: { result },
      } = await getCompanyReviewDetail({
        review_no: String(props?.review_no),
        contructor_no: String(props.contructor_no),
      });
      if (result) {
        setReview(result);
      }
    } catch (error) {
      console.error("getReview error", error);
    }
  }

  useEffect(() => {
    getReview();
  }, [props.review_no]);

  const setHeader = useSetRecoilState(headerState);
  setHeader({
    isVisible: true,
    cloaseModal: () => removeModal("REVIEW_SELECT_MODAL"),
    url: `-1`,
    title: "리뷰 상세 페이지",
    right: {
      onClick: () => {
        user?.user_no === review?.user_no && openModal();
      },
      icon: user?.user_no === review?.user_no ? menu : null,
    },
  });

  return (
    <>
      <div style={{ padding: "30px 16px" }}>
        <div
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              lineHeight: "18px",
            }}
          >
            <img
              src={
                review?.user.profile_img
                  ? review?.user.profile_img
                  : "/images/defaultImg.png"
              }
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "16px",
                marginRight: "12px",
              }}
            />
            <div>
              <div style={{ color: gray2 }}>{review?.user.nickname}</div>
              <div style={{ color: gray4 }}>{review?.createdAt}</div>
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              whiteSpace: "pre-wrap",
              padding: "16px 0",
              lineHeight: "25.2px",
              height: (review?.photo || []).length > 0 ? "100%" : "100vh",
            }}
          >
            {review?.content}
          </div>
        </div>

        <Swiper
          spaceBetween={0}
          className="mySwiper"
          slidesPerView={1}
          threshold={10}
          pagination={{
            dynamicBullets: true,
          }}
          onSwiper={setSwiperRef}
          modules={[Pagination]}
          onSlideChange={(swiper) => setPaging(swiper.activeIndex)}
          style={{ backgroundColor: white }}
        >
          {review?.photo?.map((value, index) => {
            return (
              <SwiperSlide key={index}>
                <img
                  src={value.img_url}
                  style={{
                    height: "375px",
                    width: "100%",
                    objectFit: "contain",
                  }}
                ></img>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </>
  );
}
